import React from 'react';
import { Chip } from '@mui/material';

const STATUS_CONFIG = {
  pending:  { label: 'Pending',  color: 'warning' },
  approved: { label: 'Approved', color: 'success' },
  partial:  { label: 'Partial',  color: 'info'    },
  rejected: { label: 'Rejected', color: 'error'   },
  none:     { label: 'None',     color: 'default'  },
};

const StatusChip = ({ status }) => {
  const config = STATUS_CONFIG[status?.toLowerCase()] ?? STATUS_CONFIG.none;
  return <Chip label={config.label} color={config.color} size="small" />;
};

export default StatusChip;
